import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/ofPY8ZEeCjA6SqsAuD1cbc/3.webp';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex items-center bg-white overflow-hidden py-20 md:py-28 px-4" data-id="element-138">
      <div className="relative z-10 max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-139">
        {/* Badge + Headline */}
        <div className="text-center lg:text-left order-1 lg:col-start-1 lg:row-start-1" data-id="element-140">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-brand-200 bg-brand-50 mb-8" data-id="element-141">
            <ShieldCheck className="w-4 h-4 text-brand-500" data-id="element-142" />
            <span className="text-xs md:text-sm font-medium text-brand-600 tracking-wide uppercase" data-id="element-143">
              SNPMAPS Nr. AA 15341/2025 zertifiziert
            </span>
          </div>

          <h1 className="md:text-4xl lg:text-5xl xl:text-5xl font-sans font-medium text-slate-800 text-xl leading-snug tracking-tight" data-id="element-144">
            Ganzheitliches Männer-Protokoll zur Unterstützung eines ruhigen
            Nachtschlafs – für weniger nächtliche Unterbrechungen
          </h1>
        </div>

        {/* Product Image — LCP element: no CSS filters, no blur backgrounds */}
        <div className="flex justify-center lg:justify-end relative order-2 lg:col-start-2 lg:row-start-1 lg:row-span-2" data-id="element-145">
          <div className="relative animate-float" data-id="element-146">
            <img src={PRODUCT_IMAGE} alt="UroNacht Nahrungsergänzungsmittel — Flasche mit 640mg Sägepalme und 100mg Pygeum" className="w-[340px] md:w-[420px] lg:w-[520px] h-auto relative z-10" width={520} height={780} loading="eager" fetchPriority="high" decoding="async" data-id="element-147" />
          </div>
        </div>

        {/* Subtitle + CTA */}
        <div className="text-center lg:text-left order-3 lg:col-start-1 lg:row-start-2" data-id="element-148">
          <div className="w-24 h-px bg-slate-200 mb-6 mx-auto lg:mx-0" data-id="element-149" />

          <p className="text-lg md:text-xl text-slate-500 max-w-xl mx-auto lg:mx-0 mb-10 leading-relaxed font-light" data-id="element-150">
            Wissenschaftlich fundierte Formel mit 640 mg Sägepalmen-Extrakt und
            100 mg Pygeum-Extrakt, entwickelt zur Unterstützung der normalen
            Prostatafunktion und der Gesundheit der Harnwege.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-151">
            <a href="#pricing" className="group relative inline-flex items-center justify-center px-10 py-5 text-lg font-bold text-white hover:bg-slate-800 transition-all duration-300 rounded-lg shadow-lg shadow-slate-900/20 hover:shadow-xl hover:shadow-slate-900/30 hover:-translate-y-0.5 bg-[#2f3162]" data-id="element-152">
              <span className="relative z-10" data-id="element-153">
                Jetzt tiefen Schlaf zurückgewinnen
              </span>
            </a>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 text-sm md:text-base text-slate-500" data-id="element-154">
              <span className="flex items-center gap-2 bg-slate-50 px-4 py-1.5 rounded-full border border-slate-150" data-id="element-155">
                <Check className="w-4 h-4 text-brand-500" data-id="element-156" /> Laborgeprüft
              </span>
              <span className="flex items-center gap-2 bg-slate-50 px-4 py-1.5 rounded-full border border-slate-150" data-id="element-157">
                <Check className="w-4 h-4 text-brand-500" data-id="element-158" /> Hergestellt in der
                EU
              </span>
              <span className="flex items-center gap-2 bg-slate-50 px-4 py-1.5 rounded-full border border-slate-150" data-id="element-159">
                <Check className="w-4 h-4 text-brand-500" data-id="element-160" /> Ohne Rezept
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}